const BASE = process.env.REACT_APP_API_URL_DEFAULT;

const ENDPOINT_MAP = {
  ADN: {
    MyOrders: `${BASE}adn/MyOrders`,
    MyOrdersFilters: `${BASE}adn/MyOrders/filters`,
    MyOrdersStatusCounts: `${BASE}adn/MyOrders/status-counts`,
    AcknowledgeOrder: `${BASE}adn/OrderRequestAction/acknowledge`,
    UpsertServiceDetails: `${BASE}adn/OrderDetail/upsertOrderServiceDetails`,
    UpsertOrderRequestComments: `${BASE}adn/OrderDetail/upsertOrderRequestComments`,
    ExportMyOrders: `${BASE}adn/ExcelExport/my-orders`,
  },
  AOA: {
    MyOrders: `${BASE}aoa/AOAMyOrders`,
    MyOrdersFilters: `${BASE}aoa/AOAMyOrders/filters`,
    MyOrdersStatusCounts: `${BASE}aoa/AOAMyOrders/status-counts`,
    AcknowledgeOrder: `${BASE}aoa/AOAOrderRequestAction/acknowledge`,
    UpsertServiceDetails: `${BASE}aoa/AOAOrderDetail/upsertOrderServiceDetails`,
    UpsertOrderRequestComments: `${BASE}aoa/AOAOrderDetail/upsertOrderRequestComments`,
    ExportMyOrders: `${BASE}aoa/AOAExcelExport/my-orders`,
  },
};

export const getEngagementManagerUrls = (domain = "ADN") =>
  ENDPOINT_MAP[domain] || ENDPOINT_MAP.ADN;
